export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyACt6UKlvoZMTyzXRS9Y4Pcun9ku30r8pY';

export default GOOGLE_MAPS_API_KEY;
